// The order authorization card on "Mein Support" / "My Support" is hidden by
// default. It is only shown (and the form opened) when the page is opened via
// a link with one of these query parameters, e.g. /de/mein-support/?bestellautorisierung
export const ORDER_AUTHORIZATION_PARAMS = [
  "bestellautorisierung",
  "order-authorization",
]

const LOGIN_ATTEMPT_KEY = "asp-order-authorization-login"

/**
 * Checks the current URL directly, because router.query can still be empty on
 * the first render of the static export.
 */
export const hasOrderAuthorizationParam = (): boolean => {
  if (typeof window === "undefined") {
    return false
  }
  const params = new URLSearchParams(window.location.search)
  return ORDER_AUTHORIZATION_PARAMS.some((param) => params.has(param))
}

/**
 * Remembers that a login was started from the order authorization link, so a
 * cancelled login does not start the next login right away (endless loop).
 * The flag is reset after a successful login and lives only as long as the
 * browser tab. Returns true if the login may be started.
 */
export const startOrderAuthorizationLogin = (): boolean => {
  try {
    if (sessionStorage.getItem(LOGIN_ATTEMPT_KEY)) {
      return false
    }
    sessionStorage.setItem(LOGIN_ATTEMPT_KEY, "true")
  } catch {
    // sessionStorage not available: start the login anyway
  }
  return true
}

export const resetOrderAuthorizationLogin = () => {
  try {
    sessionStorage.removeItem(LOGIN_ATTEMPT_KEY)
  } catch {
    // nothing to reset
  }
}
